import React from "react";
import PropTypes from "prop-types";
import { buildQAHook } from "shared/utils";
import styles from "./styles.css";

const Item = ({ url, title }) => (
  <div className={styles.container}>
    <a
      href={url}
      className={styles.link}
      data-qa={buildQAHook(title, "nav", "link")}
    >
      {title}
    </a>
  </div>
);

Item.propTypes = {
  url: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default Item;
